import { render, staticRenderFns } from "./PeritiImpegnati.vue?vue&type=template&id=e0eb0b1a"
import script from "./PeritiImpegnati.vue?vue&type=script&lang=js"
export * from "./PeritiImpegnati.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports